export default "__VITE_ASSET__BlbUra5E__"